import { contactData } from '@/mocks/homeData';

export default function SectionContact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading">
            联系我们
          </h2>
          <p className="text-foreground-500 text-sm mt-2">{contactData.desc}</p>
        </div>

        <div className="bg-background-100 rounded-2xl p-6 md:p-10">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-6">
            <div className="text-center p-4 rounded-xl bg-background-50">
              <span className="inline-flex w-10 h-10 items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-2">
                <i className="ri-mail-line text-lg"></i>
              </span>
              <div className="text-xs text-foreground-500 mb-1">电子邮件</div>
              <div className="text-sm font-semibold text-foreground-800 break-all">{contactData.email}</div>
            </div>
            <div className="text-center p-4 rounded-xl bg-background-50">
              <span className="inline-flex w-10 h-10 items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-2">
                <i className="ri-qq-line text-lg"></i>
              </span>
              <div className="text-xs text-foreground-500 mb-1">QQ 交流群</div>
              <div className="text-sm font-semibold text-foreground-800">{contactData.qq}</div>
            </div>
            <div className="text-center p-4 rounded-xl bg-background-50">
              <span className="inline-flex w-10 h-10 items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 mb-2">
                <i className="ri-wechat-line text-lg"></i>
              </span>
              <div className="text-xs text-foreground-500 mb-1">微信公众号</div>
              <div className="text-sm font-semibold text-foreground-800">{contactData.wechat}</div>
            </div>
          </div>

          <div className="bg-accent-50 rounded-xl p-4 text-center">
            <div className="flex items-center justify-center gap-2 mb-1">
              <i className="ri-information-line text-accent-500 text-sm"></i>
              <span className="text-xs font-semibold text-accent-700">投稿小贴士</span>
            </div>
            <p className="text-xs text-accent-600">{contactData.tips}</p>
          </div>

          <div className="mt-6 text-center">
            <a
              href={`mailto:${contactData.email}`}
              className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-lg font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-send-plane-line text-lg"></i>
              发送邮件
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}